export class TermsForm {
  fileName: string = "";
  firmSize: string = "";
  businessName: string = "";
  businessAddress: string = "";
  businessStructure: string = "";
  establishedYears: string = "";
  annualTurnover: string = "";
  percentTotalAnnualTurnOver: string = "";
  relevanceOfCVs: string = "";
  localPresences: string = "";
  noOfInstallationsDone: string = "";
  experienceNigeriaMarket: string = "";
  experienceSolarSystem: string = "";
  levelOfWarrantySolar: string = "";
  renewableEnergy: string = "";
  totalVendorPercentage: string = "";
}

export interface ITermsResponse {
  data: any;
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}

export enum FileName {
  memorandum = "memorandum",
  vendorchecklist = "vendorchecklist",
  cac = "CAC.pdf",
}
